import type { Action } from './actions'

export type DataBindingActionDefinition = {
  collectionId: string
  name: Action
  label: string
  experiment?: string
  supportedInsideRepeater?: boolean
}

export const actions: DataBindingActionDefinition[] = [
  {
    collectionId: 'StoreCatalog/Products',
    name: 'tpa/quicklyViewProduct',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_AddProductToCart',
    supportedInsideRepeater: true,
  },
  {
    collectionId: 'StoreCatalog/Products',
    name: 'tpa/quicklyViewProduct',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_QuicklyViewProduct',
    supportedInsideRepeater: true,
  },
  {
    collectionId: 'Stores/Products',
    name: 'tpa/addProductToCart',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_AddProductToCart',
    supportedInsideRepeater: true,
  },
  {
    collectionId: 'Stores/Products',
    name: 'tpa/quicklyViewProduct',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_QuicklyViewProduct',
    supportedInsideRepeater: true,
  },
  {
    collectionId: 'Stores/Variants',
    name: 'tpa/addVariantToCart',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_AddVariantToCart',
    supportedInsideRepeater: true,
  },
  {
    collectionId: 'PaidPlans/Plans',
    name: 'tpa/purchasePricingPlan',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_PurchasePricingPlan',
    supportedInsideRepeater: true,
  },
  {
    collectionId: 'PaidPlans/Plans',
    name: 'tpa/pricingPlansNavigateToCheckout',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_PricingPlansNavigateToCheckout',
    supportedInsideRepeater: true,
  },
]
